export class Mouse {
  x: number;
  y: number;
}
